'use client';

import { Button } from '@nf/ui';
import { useTranslations } from 'next-intl';
import { useBetslipStore } from '@/store/betslip';
import { Icon } from '@/components/icons/svg-icons';
import clsx from 'clsx';
import { betslipStyle } from '@/features/betslip/betslip.style';
import { confirmBetStyle } from '../confirm-bet/confirm-bet.style';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useBetslipContext } from '../contexts/betslip-context';
import { useFloatBetslip } from '../hook/use-float-betslip';
import { useAsideBetslip } from '../hook/use-aside-betslip';

export const ConfirmBetModalHeader = () => {
	const t = useTranslations('General');
	const { isIndependentMode } = useBetslipContext();
	const { activeFloatBetSlip } = useFloatBetslip();
	const { activeAsideBetSlip } = useAsideBetslip();
	const [
		isParlayMode,
		isConfirmBet,
		getTotalBet,
		removeAllTicket,
		setIsConfirmBet,
		toggleIsExpand,
	] = useBetslipStore(
		state => [
			state.isParlayMode,
			state.isConfirmBet,
			state.getTotalBet,
			state.removeAllTicket,
			state.setIsConfirmBet,
			state.toggleIsExpand,
		]
	);

	const isConfirmBetHeader = isConfirmBet && !isParlayMode;

	const closeModal = () => {
		if (isConfirmBet) {
			setKafka();
			removeAllTicket();
			setIsConfirmBet(false);
		}
		toggleIsExpand();
	}

	const setKafka = () => {
		const kafkaData = {
			note: KafkaNote.MarsV1,
			type: isConfirmBetHeader ? 10 : 11,
			action: isConfirmBetHeader ? 6 : 3
		}
		setKafkaNormal(kafkaData);
	}

	const isFloatStyle = activeAsideBetSlip || activeFloatBetSlip;

	return (
		<div className={clsx(
			confirmBetStyle.confirmBetheader,
			{ [confirmBetStyle.floatConfirmBetheader]: isFloatStyle }
		)}
		>
			<div className={betslipStyle.modalHeaderTitle}>
				<div className={betslipStyle.modalHeaderText}>{t('Betsilp')}</div>
				<div 
					className={clsx(
						confirmBetStyle.headerBadge, 
						{ [confirmBetStyle.floatHeaderBadge]: isFloatStyle }
					)}
				>
					{getTotalBet(isIndependentMode, true)}
				</div>
			</div>
			<div className={betslipStyle.modalHeaderTools}>
				<Button
					variant="icon"
					onClick={closeModal}
					className={clsx(
						confirmBetStyle.closeButton, 
						{ [confirmBetStyle.floatCloseButton]: isFloatStyle }
					)}
				>
					<Icon name={isConfirmBet ? 'close-big' : 'collapse'} />
				</Button>
			</div>
		</div>
	)
}